const queryStringOption = { allowDots: true };

export default queryStringOption;
